import React from "react";

export function EmptyState({
  title = "No records yet",
  description = "When data is available it will appear here.",
  action = null,
  icon = null,
}) {
  return (
    <div className="crane-empty-state" role="status">
      {icon && <div className="crane-empty-state__icon">{icon}</div>}
      <h3 className="crane-empty-state__title">{title}</h3>
      {description && <p className="crane-empty-state__desc">{description}</p>}
      {action && <div className="crane-empty-state__action">{action}</div>}
    </div>
  );
}

export function AccessDenied({
  title = "Access denied",
  description = "You do not have permission to view this resource.",
}) {
  return (
    <div className="crane-access-denied" role="alert">
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
}

export function ErrorState({
  title = "Something went wrong",
  description = "Please try again. If the problem continues, contact your administrator.",
  onRetry = null,
}) {
  return (
    <div className="crane-error-state" role="alert">
      <h3>{title}</h3>
      <p>{description}</p>
      {onRetry && (
        <button type="button" className="crane-btn crane-btn--primary" onClick={onRetry}>
          Retry
        </button>
      )}
    </div>
  );
}

export function Skeleton({ rows = 3, height = 16 }) {
  return (
    <div className="crane-skeleton" aria-busy="true" aria-label="Loading">
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="crane-skeleton__row"
          style={{ height, width: `${90 - (i % 3) * 10}%` }}
        />
      ))}
    </div>
  );
}

/** Stitch-aligned page header with optional breadcrumbs */
export function PageHeader({ crumbs = [], title, description = null, actions = null }) {
  return (
    <header className="crane-page-header">
      {crumbs.length > 0 && (
        <div className="crane-page-header__crumbs" aria-label="Breadcrumb">
          {crumbs.map((c, i) => (
            <React.Fragment key={`${c}-${i}`}>
              {i > 0 && <span aria-hidden="true">›</span>}
              <span>{c}</span>
            </React.Fragment>
          ))}
        </div>
      )}
      <div style={{ display: "flex", justifyContent: "space-between", gap: 12, flexWrap: "wrap", alignItems: "flex-start" }}>
        <div>
          <h1 className="crane-page-header__title">{title}</h1>
          {description && <p className="crane-page-header__desc">{description}</p>}
        </div>
        {actions && <div className="crane-page-header__actions">{actions}</div>}
      </div>
    </header>
  );
}

export default { EmptyState, AccessDenied, ErrorState, Skeleton, PageHeader };
